import {Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild} from '@angular/core';
import { Listing } from '../../classes/listing';
import {HasSubscriptions} from '../has-subscriptions';
import {SavedSearch} from '../../classes/saved-search';
import {SavedSearchLocationType, LoginSource, SCREEN_SIZE } from '../../classes/enums'
import { CommunicationService } from '../../services/communication.service';
import { CredentialsService } from '../../services/credentials.service';
import {TranslateService} from '@ngx-translate/core';
import { InputComponent } from '../../components/forms/input/input.component';
import { PreferencesService } from '../../services/preferences.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import {ConfirmationService} from '../../services/confirmation/confirmation.service';
import {DomManipulationService} from '../../services/dom-manipulation/dom-manipulation.service';
import { Router } from '@angular/router';
import { AnalyticsService } from '../../services/analytics/analytics.service';
import { SaveSearchService } from '../../services/save-search.service';
import { PostAuthenticationService } from '../../services/post-authentication.service';

@Component({
  selector: 'app-save-search',
  templateUrl: './save-search.component.html',
  styleUrls: ['./save-search.component.scss']
})
export class SaveSearchComponent extends HasSubscriptions implements OnInit, OnChanges {
  @Input() listing: Listing;
  @Input() parent: string;
  @ViewChild(InputComponent) inputComponent: InputComponent;
  @Output() closed = new EventEmitter<void>();
  savedSearches: SavedSearch[] = [];
  saveSearchForm: FormGroup;
  screenSize: SCREEN_SIZE;
  hasError: {
    duplicateName: boolean
  } = {
    duplicateName: false
  };
  submitted = false;
  SavedSearchLocationType = SavedSearchLocationType;
  SavedSearch = SavedSearch;

  constructor(
    private preferencesService: PreferencesService, private communicationService: CommunicationService,
    private _saveSearchService: SaveSearchService, private _postAuthenticationService : PostAuthenticationService,
    private credentialsService: CredentialsService, private translateService: TranslateService,
    private fb: FormBuilder, private confirmationSerice: ConfirmationService,
    private router: Router,
    private domManipulationService: DomManipulationService, private _analyticsService: AnalyticsService) {
    super();
    this.saveSearchForm = this.fb.group({
      name: ['', [Validators.required]],
      notification: [false],
    });
  }

  ngOnInit() {
    this.addSub(this.communicationService.selectedSaveSearch.subscribe((s) => {
      if (s) {
        this.saveSearchForm.setValue({ name: s.name });
        this.saveSearchForm.setValue({ notification: s.notificationsEnabled || false});
      }
    }));
    this.addSub(this.communicationService.screenSize.subscribe((screenSize) => {
      this.screenSize = screenSize;
    }));



    this.preferencesService.savedSearchesChanged.subscribe((s) => this.savedSearches = s);
    this.domManipulationService.focus(this.inputComponent.inputRef);
  }

  ngOnChanges(changes: SimpleChanges): void { }

  onSubmit() {
    const name = this.saveSearchForm.get('name').value;
    const notification = this.saveSearchForm.get('notification').value;
    // No duplicate names allowed for searches
    if (this.preferencesService.doesSavedSearchExist(name)) {
      this.hasError.duplicateName = true;
      return;
    }

    this.hasError.duplicateName = false;
    this.addSub(this.credentialsService.isLoggedIn.subscribe((isAuthenticated: boolean) => {
      if (!isAuthenticated && notification) {
        this._postAuthenticationService.storeSaveSearch(name, notification, this.listing);
        if (this.screenSize > SCREEN_SIZE.TABLET_LANDSCAPE_UP) {
          this.router.navigate(['/', { outlets: { popup: [ 'register-login', LoginSource.Radar ] } }]);
        }
        else {
          this.communicationService.showSignIn.next(LoginSource.Radar);
        }
      }
      else{
        this._saveSearchService.saveSearch(name, notification, this.listing);
      }
    }));
    this.submitted = true;
    this.closed.emit();
  }

  updateSavedSearch(s: SavedSearch) {
    if (this.confirmationSerice.showConfirmation(this.translateService.instant('drawer.save-search.confirm-update', {x: s.name}))) {
      this.preferencesService.updateSavedSearch(s).then((search: SavedSearch) => {
        this.closed.emit();
        this.communicationService.notifications.bottomNotification.next(this.translateService.instant('actions.update-saved-search', {x: s.name}));
        this.communicationService.selectedSaveSearch.next(search);
      }).catch(() => {
        // TODO: errors
      });
    }
  }
}

